import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Lista de productos con potencial de venta',
    description: 'Accede a ideas reales con demanda comprobada para empezar sin perder tiempo ni dinero.',
    value: 49,
    image: 'https://cdn.magicpatterns.com/uploads/pCqXRtbdWGJeAzDY9PXmug/bono1.png',
    alt: 'Lista de productos listos para vender en Amazon'
  }, {
    title: 'Plantilla práctica para elegir productos ganadores',
    description: 'Evalúa productos con un sistema claro, analiza oportunidades reales y toma decisiones con más seguridad para aumentar tus probabilidades de venta.',
    value: 39,
    image: 'https://cdn.magicpatterns.com/uploads/kSj8buCdK5HEUYnZcXF3Fa/ChatGPT_Image_14_abr_2026,_07_01_18.png',
    alt: 'Plantilla premium para elegir productos ganadores'
  }, {
    title: 'Checklist completo para lanzar sin errores',
    description: 'Sigue cada paso correctamente con una guía clara y estructurada que te ayudará a evitar errores que hacen perder dinero al empezar en Amazon.',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/obLgyJo2bu2NwaNpfecJbv/ChatGPT_Image_14_abr_2026,_06_54_12.png',
    alt: 'Checklist completo para lanzar tu producto sin errores'
  }];
  return <section className="bg-brand-white py-24 px-6" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <FadeIn data-id="element-48">
          <div className="text-center mb-16" data-id="element-49">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-beige rounded-full mb-6" data-id="element-50">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-51" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green" data-id="element-52">
              Además, recibirás bonos diseñados para ayudarte a avanzar más
              rápido:
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-53">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-54">
              <div className="bg-brand-beige/30 border border-brand-beige rounded-2xl shadow-sm hover:shadow-md hover:border-brand-gold/30 transition-all h-full flex flex-col" data-id="element-55">
                {/* Image */}
                <div className="p-5 pb-0" data-id="element-56">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-xl object-contain" data-id="element-57" />
                </div>

                {/* Content */}
                <div className="p-6 pt-5 flex flex-col flex-1 text-center" data-id="element-58">
                  <h3 className="text-lg md:text-xl font-bold text-brand-text mb-3" data-id="element-59">
                    {bonus.title}
                  </h3>
                  <p className="text-brand-text/70 text-sm md:text-base leading-relaxed mb-5 flex-1" data-id="element-60">
                    {bonus.description}
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-61">
                    <span className="text-xs font-semibold uppercase tracking-wider text-brand-text/50" data-id="element-62">
                      Valor:
                    </span>
                    <span className="text-2xl font-bold text-brand-gold line-through decoration-brand-green/30" data-id="element-63">
                      ${bonus.value}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-64">
          <div className="text-center" data-id="element-65">
            <p className="text-2xl md:text-3xl font-bold text-brand-green mb-8" data-id="element-66">
              💥 TODO INCLUIDO SIN COSTO ADICIONAL
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-67">
          <div className="text-center max-w-3xl mx-auto" data-id="element-68">
            <p className="text-lg text-brand-text/80 mb-3" data-id="element-69">
              Todo este sistema fue diseñado para que no empieces desde cero y
              puedas avanzar con claridad desde el primer día.
            </p>
            <p className="text-lg text-brand-green font-semibold" data-id="element-70">
              No solo estás comprando información… Estás accediendo a una
              estructura completa para empezar correctamente.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}